import { constants } from '@/config';
import { createHttpClient } from './httpClient';
import { attachMocks } from './mock';
import { isDemoEnvironment } from './environment';

const client = createHttpClient({ baseURL: constants.URL });

export default isDemoEnvironment() ? attachMocks(client) : client;
